import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useUser } from '@/contexts/UserContext'
import { getDashboard, meKeys } from '@/lib/api/me'
import { getAreaTree, areaKeys } from '@/lib/api/areas'
import { AreaCardsGrid } from '@/components/ged/AreaCardsGrid'

export function Home() {
  const { user } = useUser()

  const { data: dashboard } = useQuery({
    queryKey: meKeys.dashboard(),
    queryFn: getDashboard,
  })

  const { data: tree = [] } = useQuery({
    queryKey: areaKeys.tree(),
    queryFn: getAreaTree,
  })

  const todayRaw = format(new Date(), "EEEE, d 'de' MMMM 'de' yyyy", { locale: ptBR })
  const today = todayRaw.charAt(0).toUpperCase() + todayRaw.slice(1)
  const hour = new Date().getHours()
  const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite'
  const displayName = user?.email.split('@')[0] ?? ''

  const cards = [
    [dashboard?.documentsAvailable ?? 0, 'documentos disponíveis'],
    [dashboard?.areasWithAccess ?? 0, 'áreas com acesso'],
    [dashboard?.newThisWeek ?? 0, 'novos esta semana'],
    [dashboard?.notViewedYet ?? 0, 'não vistos'],
  ] as const

  return (
    <div style={{ padding: '28px 32px', maxWidth: 1180 }}>
      {/* Hero */}
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontSize: 12, color: 'var(--ev-fg-muted)', marginBottom: 6 }}>{today}</div>
        <h1 style={{ fontSize: 30, color: 'var(--ev-fg-strong)', marginBottom: 6 }}>
          {greeting}, {displayName}.
        </h1>
        <p style={{ color: 'var(--ev-fg-muted)', fontSize: 14 }}>
          {tree.length} {tree.length === 1 ? 'grupo' : 'grupos'} · {dashboard?.documentsAvailable ?? 0} documentos.
        </p>
      </div>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28 }}>
        {cards.map(([n, l]) => (
          <div key={l} style={{ background: 'var(--ev-bg-elevated)', border: '1px solid var(--ev-border)', borderRadius: 10, padding: '14px 16px' }}>
            <div style={{ fontSize: 22, fontWeight: 600, color: 'var(--ev-fg-strong)', letterSpacing: '-0.02em' }}>
              {n.toLocaleString('pt-BR')}
            </div>
            <div style={{ fontSize: 12, color: 'var(--ev-fg-muted)' }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Índice */}
      <h3 style={{ fontSize: 15, color: 'var(--ev-fg-strong)', marginBottom: 12 }}>Índice</h3>
      <AreaCardsGrid nodes={tree} topLevel />
    </div>
  )
}
